import React, { Component } from "react";
import { Accordion, Table } from "semantic-ui-react";
import _ from "lodash";
import PropertyDataRecord from "./PropertyDataRecord";

class PropertyDataSection extends Component {
  state = {
    activeIndex: 0,
    rows: [],
    savedResultID: "",
    internalID: "",
    martinRecord: undefined,
  };

  componentWillReceiveProps(nextProps) {
    if (this.state.martinRecord !== nextProps.martinRecord) {
      this.setState({
        martinRecord: nextProps.martinRecord,
      });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rows = [];
    if (props.martinRecord !== undefined) {
      _.forEach(
        _.get(props.martinRecord, "addresses[0].address"),
        (addressNode, index) => {
          const propertyData = _.get(addressNode, "propertyData[0]");
          if (
            propertyData !== undefined &&
            Object.keys(propertyData).length > 1
          ) {
            const propData = (
              <PropertyDataRecord props={props} addressNode={addressNode} />
            );
            if (propData !== undefined) {
              rows.push(
                <Table.Row key={`property_data_row_${index}`}>
                  <Table.Cell>{propData}</Table.Cell>
                </Table.Row>
              );
            }
          }
        }
      );
      const recLength = rows.length > 0 ? rows.length : 0;
      if (recLength > 0) {
        props.updateItemCountBySection(
          props.sectionName,
          recLength,
          props.isSecondaryCount
        );
      }
      this.setState({
        rows,
        activeIndex: 0,
      });
    }
  };

  render() {
    if (this.state.rows !== null && this.state.rows.length === 0) return null;
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`propertyDataTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Property Records
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`propertyDataBody`}
          active={this.state.activeIndex === 0}
        >
          <Table className="table-no-border-and-padding">
            <Table.Body>
              <Table.Row className="report-sub-section-header">
                <Table.Cell>
                  Property Records Associated with Subject
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>NO RECORDS FOUND</Table.Cell>
              </Table.Row>
              <Table.Row className="report-sub-section-header">
                <Table.Cell>Property Records by Address</Table.Cell>
              </Table.Row>
              {this.state.rows}
            </Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default PropertyDataSection;



// WEBPACK FOOTER //
// ./src/components/reports/PropertyDataSection.js